import { ActivityType, RiskCategory, RoleId } from '../../amorg-common';
export const ColorNormal = `hsl(210, 100%, 70%)`;
export const ColorLight = `hsl(210, 100%, calc(70% + 20%))`;
export const ColorDark = `hsl(210, 100%, calc(70% - 50%))`;


export const TextNormal = "rgba(0, 0, 0, 1)";

export const rawColors = {
    blue: {
        normal: "rgba(120, 184, 255, 1)",
        dark: "rgba(0, 77, 163, 1)",
        darkExtreme: "rgba(16, 15, 50, 1)",
        light: "rgba(189, 220, 255, 1)",
        lightExtreme: "rgba(232, 243, 255, 1)",
    },
    gray: {
        darkExtreme: "rgba(43, 43, 43, 1)",
        dark: "rgba(63, 63, 63, 1)",
        normal: "rgba(120, 120, 120, 1)",
        light: "rgba(189, 189, 189, 1)",
        lightExtreme: "rgba(240, 240, 240, 1)",
        lightExtremeSuper: "rgba(248, 248, 248, 1)",
        normalOpacity: "rgba(120, 120, 120, 0.5)",
    },
    red: {
        normal: "rgba(201, 39, 79, 1)",
        dark: "rgba(135, 14, 45, 1)",
        light: "rgba(255, 139, 168, 1)",

    },
    green: {
        normal: "rgba(56, 117, 30, 1)",
        dark: "rgba(39, 81, 21, 1)",
        light: "rgba(126, 177, 104, 1)",

    },
    yellow: {
        normal: "rgba(215, 212, 51, 1)",
        dark: "rgba(185, 182, 21, 1)",
        light: "rgba(255, 255, 122, 1)",
    },
    beige: {
        normal: "rgb(222, 215, 199)",
        dark: "rgb(189, 177, 149)",
    },
    white: "white",
    black: "black"
};

const botoxGray = {
    normal: "rgba(204, 204, 204, 1)",
    dark: "rgba(63, 63, 63, 1)",
    light: "rgba(222, 222, 222, 1)",
};


export const botoxColors = {
    border: botoxGray,
    gray: botoxGray,
    
}

// Hues distributed using the golden angle so neighboring pairs are always visually distinct.
const indexingColors = [
    { dark: '#b05252', light: '#f1bcbc' },
    { dark: '#52a86a', light: '#bcf1cb' },
    { dark: '#895ca8', light: '#dbbcf1' },
    { dark: '#b0a452', light: '#f1eabc' },
    { dark: '#52a0a8', light: '#bce8f1' },
    { dark: '#b0527f', light: '#f1bcd8' },
    { dark: '#6aa852', light: '#c9f1bc' },
    { dark: '#625ca8', light: '#bebcf1' },
    { dark: '#b07a52', light: '#f1cdbc' },
    { dark: '#52a886', light: '#bcf1dd' },
    { dark: '#a852a8', light: '#ecbcf1' },
    { dark: '#9ca852', light: '#e6f1bc' },
    { dark: '#5288a8', light: '#bcd6f1' },
    { dark: '#b05266', light: '#f1bcc7' },
    { dark: '#52a858', light: '#bcf1c0' },
    { dark: '#755ca8', light: '#d0bcf1' },
    { dark: '#b09452', light: '#f1dfbc' },
    { dark: '#52a8a5', light: '#bcf1ef' },
    { dark: '#b0528e', light: '#f1bce3' },
    { dark: '#7da852', light: '#d4f1bc' },
];

const cardBorder = 'rgb(222,222,222)';

const background = {
    white: 'white',
    beige: rawColors.beige.normal,
    gray: rawColors.gray.lightExtreme,
};

const stateColors = {

    // these two should be removed - are not general enough
    pending: rawColors.gray.light,
    info: rawColors.blue.dark,

    success: rawColors.green.normal,
    warning: rawColors.yellow.dark,
    error: rawColors.red.normal
};


// How about just light, normal, disabled and state (success, error, warning) ?
const textColors = {
    normal: rawColors.gray.dark,

    // what does muted mean ? vs light ?
    muted: rawColors.gray.light,

    // Can we make do with just one light text ?
    light: rawColors.gray.light,
    lightExtreme: rawColors.gray.lightExtreme,

    gray: {
        contrastForWhite: 'rgb(88,88,88)',
        normal: rawColors.gray.normal,
        dark: rawColors.gray.dark,
        light: rawColors.gray.light,
        lightExtreme: rawColors.gray.lightExtreme
    },
    state: stateColors,
    inactive: rawColors.gray.light,
    highlighted: rawColors.blue.dark,
    white: rawColors.white,
    black: rawColors.black,
    active: rawColors.blue.dark
};

const inputState = {
    default: {
        border: botoxColors.gray.normal,
        borderHover: botoxColors.gray.dark,
        borderActive: botoxColors.gray.dark,
        borderFocus: botoxColors.gray.dark,
        text: textColors.normal,
        placeholderText: textColors.light
    },
    error: {
        border: rawColors.red.light,
        borderHover: rawColors.red.dark,
        borderActive: rawColors.red.dark,
        borderFocus: rawColors.red.dark,
        text: textColors.state.error,
        placeholderText: textColors.light
    },
    // Should be made reusable - lots of use cases
    disabled: {
        background: rawColors.gray.lightExtreme,
        border: rawColors.gray.light,
        text: textColors.muted,
        placeholderText: textColors.muted
    }
};

const surveyScores = {
    score1: '#e15252',
    score2: '#f1a106',
    score3: 'rgb(211, 211, 211)',
    score4: '#33d498',
    score5: '#08976b'
}

// export const amorgColors:CustomizableColors = {
//     primary:{
//         light:rawColors.blue.light,
//         normal:rawColors.blue.normal,
//         dark:rawColors.blue.dark,
//     },

//     mainNavigation:{
//         background:rawColors.blue.darkExtreme,
//         backgroundSelected:rawColors.blue.normal,
//         divider:rawColors.blue.normal
//     },
// };



//TODO: derive less used components from core components.
// Eg. should tabber use stylin from filled button ?

export const colors = {
    pageSection:{
        header: {
            variant:{
                default:rawColors.white,
                dark:rawColors.gray.dark
            }
        }
    },
    section: {
        border:{
            light: cardBorder,
            dark: cardBorder,
            normal: cardBorder,
        }
    },
    activityCard:{
        background: rawColors.white,
        backgroundHightlight: rawColors.blue.light,
        border: rawColors.blue.normal,
        headerBackground: rawColors.gray.dark,
        headerColor: rawColors.white,
    },
    mainNavigation: {
        background: rawColors.blue.darkExtreme,
        backgroundSelected: rawColors.blue.normal,
        divider: rawColors.blue.normal,
        color: textColors.white,
        colorSelected: textColors.black,
    },
    button: {
        filled: {
            border: "0",
            text: textColors.white,
            textHover: textColors.white,
            textDisabled: textColors.light,
            background: rawColors.blue.normal,
            backgroundHover: rawColors.blue.dark,
            backgroundDisabled: inputState.disabled.background
        },
        outlined: {
            border: `1px solid ${rawColors.blue.light}`,
            text: rawColors.blue.dark,
            textHover: rawColors.blue.dark,
            textDisabled: textColors.light,
            background: background.white,
            backgroundHover: rawColors.blue.light,
            backgroundDisabled: background.white
        },
        text: {
            border: `0`,
            text: rawColors.blue.dark,
            textHover: rawColors.blue.dark,
            textDisabled: textColors.light,
            background: 'transparent',
            backgroundHover: rawColors.blue.light,
            backgroundDisabled: 'transparent'
        },
        textWhite: {
            border: `0`,
            text: textColors.white,
            textHover: textColors.white,
            textDisabled: textColors.light,
            background: 'transparent',
            backgroundHover: rawColors.blue.light,
            backgroundDisabled: 'transparent'
        },
        light: {
            border: `0`,
            text: rawColors.blue.dark,
            textHover: rawColors.blue.dark,
            textDisabled: textColors.light,
            background: rawColors.blue.light,
            backgroundHover: rawColors.blue.normal,
            backgroundDisabled: inputState.disabled.background
        },
        destructive: {
            border: `0`,
            text: rawColors.white,
            textHover: rawColors.white,
            textDisabled: rawColors.gray.light,
            background: rawColors.red.normal,
            backgroundHover: rawColors.red.dark,
            backgroundDisabled: rawColors.gray.lightExtreme
        },
        destructiveText: {
            border: `0`,
            text: rawColors.red.normal,
            textHover: rawColors.white,
            textDisabled: rawColors.gray.light,
            background: `transparent`,
            backgroundHover: rawColors.red.normal,
            backgroundDisabled: 'transparent'
        },
        clean: {
            border: `0`,
            text: textColors.normal,
            textHover: textColors.normal,
            textDisabled: rawColors.gray.light,
            background: `transparent`,
            backgroundHover: `transparent`,
            backgroundDisabled: 'transparent'
        },
        dimmed: {
            border: `0`,
            text: textColors.muted,
            textHover: textColors.normal,
            textDisabled: rawColors.gray.light,
            background: `transparent`,
            backgroundHover: `transparent`,
            backgroundDisabled: 'transparent'
        }
    },
    popupMenuCustomButton: {
        backgroundHover: rawColors.gray.lightExtreme,
        borderHover: rawColors.blue.light,
    },
    card: {
        light: {
            default: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.blue.normal,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        lightGray: {
            default: {
                border: cardBorder,
                background: rawColors.gray.lightExtremeSuper,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.gray.light,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.gray.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        darkBlue: {
            default: {
                border: cardBorder,
                background: rawColors.blue.darkExtreme,
                color: rawColors.white
            },
            hover: {
                border: cardBorder,
                background: rawColors.blue.darkExtreme,
                color: rawColors.white
            },
            active: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        outlined: {
            default: {
                border: cardBorder,
                background: rawColors.white,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        attention: {
            default: {
                border: cardBorder,
                background: rawColors.beige.normal,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.beige.dark,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        none: {
            default: {
                border: rawColors.white,
                background: rawColors.white,
                color: rawColors.gray.dark
            },
            hover: {
                border: rawColors.gray.light,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            active: {
                border: rawColors.gray.light,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: rawColors.white,
                background: rawColors.white,
                color: rawColors.gray.light
            }
        },
    },
    avatar: {
        background: rawColors.blue.normal,
        backgroundLight: rawColors.blue.light,
        backgroundError: rawColors.red.dark,
        backgroundMuted: rawColors.gray.light,
        userRole: {
            employer: rawColors.blue.dark,
            employee: rawColors.blue.normal,
        },
        text: textColors.white,
        selectedBorder: rawColors.gray.darkExtreme
    },
    table: {
        border: rawColors.gray.lightExtreme,
        borderInternal: rawColors.gray.lightExtreme,
        headerText: rawColors.gray.dark,
        cellText: rawColors.gray.dark,
        backgroundHover: rawColors.gray.lightExtreme,
        trOdd: rawColors.white,
        trEven: rawColors.gray.lightExtreme
    },
    withSaveButton: {
        cancel: {
            border: rawColors.red.normal,
            borderHover: rawColors.red.dark,
            background: rawColors.white,
            color: rawColors.red.normal,
            colorHover: rawColors.red.dark
        },
        save: {
            border: rawColors.blue.normal,
            borderHover: rawColors.blue.dark,
            background: rawColors.white,
            color: rawColors.blue.normal,
            colorHover: rawColors.blue.dark
        }
    },
    link: {
        dark: {
            normal: 'rgb(47, 45, 151)',
            hover: 'rgb(47, 45, 151, 0.8)',
        },
        default: {
            normal: rawColors.blue.normal,
            hover: rawColors.blue.light
        },
        footer: {
            normal: textColors.normal,
            hover: rawColors.red.normal
        }
    },
    footer: {
        background: rawColors.blue.lightExtreme,
    },
    getUserRoleColor,
    inputState,
    editableInput: {
        backgroundHover: rawColors.gray.lightExtreme,
    },
    divider: {
        default: cardBorder,
        medium: rawColors.gray.light,
        light: rawColors.gray.light,
        blue: rawColors.blue.normal
    },

    indexed: {
        dark: indexingColors.map(c => c.dark),
        light: indexingColors.map(c => c.light)
    },
    newIndexed:indexingColors,
    fancyRadioButton: {
        border: rawColors.gray.light,
        borderFocus: rawColors.gray.normal,
        background: rawColors.gray.lightExtremeSuper,
        backgroundSelected: rawColors.white,
        backgroundDisabled: rawColors.gray.lightExtreme,
        selectedColor:{
            neutral: rawColors.gray.normal,
            success: rawColors.green.light,
            failure: rawColors.red.normal
        }
    },
    graphs: {
        survey: {
            score:surveyScores,
            noScore: rawColors.blue.normal,
            getAnswerAverageColor: (average: number) =>
            {
                if (average < 1.5)
                    return surveyScores.score1;
                if (average < 2.5)
                    return surveyScores.score2;
                if (average < 3.5)
                    return surveyScores.score3;
                if (average < 4.5)
                    return surveyScores.score4;

                return surveyScores.score5;
            },
            getGoodScorePctColor: (scorePct: number) =>
            {
                if (scorePct > 80)
                    return surveyScores.score5;
                if (scorePct > 70)
                    return surveyScores.score4;
                if (scorePct > 50)
                    return surveyScores.score3;
                if (scorePct > 30)
                    return surveyScores.score2;

                return surveyScores.score1;
            }
        },
        activityTimeline: {
            getColor: (type: ActivityType) =>
            {
                if (type === 'AnnualWorkgroupStatus')
                    return rawColors.blue.dark;
                // return rawColors.blue.dark;
                else if (type === 'WorkgroupMeeting')
                    return rawColors.blue.normal;
                // return rawColors.blue.normal;
                else if (type === 'WorkplaceAssessment')
                    return rawColors.green.normal;
                // return rawColors.green.light;
                else if (type === 'SafetyInspection')
                    return rawColors.green.dark;
                // return rawColors.green.dark;
                else if (type === 'CustomForm')
                    return rawColors.yellow.dark;
                // return rawColors.blue.light;

                else
                    return rawColors.blue.normal;
            },
            hover: rawColors.beige.normal,
        },
        articleTimeline: {
            getColor: (listName: string) =>
            {
                if (listName === 'Arbejdsmiljø')
                    return rawColors.blue.dark;
                else if (listName === 'Miljø')
                    return rawColors.blue.normal;
                else if (listName === 'Brand')
                    return rawColors.green.light;
                else if (listName === 'Farligt gods')
                    return rawColors.green.dark;
                else if (listName === 'Energi')
                    return rawColors.blue.light;
                else
                    return rawColors.gray.normal;
            },
            hover: rawColors.beige.normal,
        },
        progressBar: rawColors.blue.normal,
        segmentBar: {
            default: rawColors.gray.lightExtreme,
            success: rawColors.green.normal,
            failure: rawColors.red.normal,
            selected: rawColors.yellow.dark,
        },
        completionPanel: {
            unfavorable: 'rgb(215, 178, 51)',
            neutral: 'rgb(126, 177, 104)',
            favorable: 'rgb(39, 81, 21)'
        }
    },
    onOff: {
        border: rawColors.green.light,
        inactiveBorder: rawColors.gray.lightExtreme,
        fullColor: {
            activeColor: rawColors.green.dark,
            inactiveColor: rawColors.red.dark,
            activeBackground: rawColors.green.light,
            inactiveBackground: rawColors.red.normal
        },
        default: {
            activeColor: rawColors.green.dark,
            inactiveColor: textColors.normal,
            activeBackground: rawColors.green.light,
            inactiveBackground: rawColors.gray.light
        }
    },
    suggester: {
        optionList: {
            background: rawColors.white,
            backgroundHover: rawColors.blue.light,
            border: rawColors.blue.normal,
        }
    },
    text: { ...textColors },
    icon: {
        default: rawColors.gray.dark,
        passive: rawColors.gray.light,
        active: rawColors.blue.dark,
        disabled: rawColors.gray.lightExtreme,
        white: rawColors.white,
        ...stateColors,
    },
    importance: {
        default: rawColors.gray.dark,
        high: rawColors.red.normal,
        medium: rawColors.yellow.normal,
        low: rawColors.green.light
    },
    tabber: 
    {
        containerBorder: rawColors.gray.lightExtreme,
        avatarBackground: rawColors.blue.normal,
        // TextVariants simply use the background color for the bottom border
        default:{
            background:'transparent',
        },
        hover:{
            background: rawColors.blue.light,
        },
        selected:{
            background: rawColors.blue.lightExtreme,
        },
        disabled:{
            background:'transparent',
        },
        colorDisabled: textColors.muted,
    },
    tabber2: {
        button: {
            border: cardBorder,
        }
    },
    menu: {
        background: rawColors.white,
        backgroundSelected: rawColors.blue.light,
        border: rawColors.gray.light,
        default: {
            backgroundHover: rawColors.blue.light
        },
        emphasized: {
            backgroundHover: rawColors.blue.light
        },
        destructive: {
            backgroundHover: rawColors.red.light
        },
        strikeThrough: {
            backgroundHover: rawColors.blue.light
        }
    },
    listRow: {
        normal: {
            border: cardBorder,
            background: rawColors.white,
            backgroundHover: rawColors.gray.lightExtremeSuper,
        },
        lightGray: {
            border: cardBorder,
            background: rawColors.gray.lightExtreme,
            backgroundHover: rawColors.gray.lightExtremeSuper,
        }
    },
    radialChart: {
        red: rawColors.red.normal,
        green: rawColors.green.normal,
        yellow: rawColors.yellow.normal,
        blue: rawColors.blue.normal,
        unfilled: rawColors.gray.lightExtreme
    },
    radioButtonButton: {
        background: rawColors.white,
        backgroundSelected: rawColors.blue.normal,
        backgroundDisabled: rawColors.gray.lightExtreme,
        border: rawColors.gray.light,
        text: textColors.normal,
        textHover: textColors.white,
        textDisabled: rawColors.gray.light
    },
    buttonRadioButton: {
        background: rawColors.white,
        backgroundHover: rawColors.blue.light,
        backgroundSelected: rawColors.blue.light,
        backgroundDisabled: rawColors.gray.lightExtreme,
        text: textColors.normal,
        textHover: textColors.normal,
        textSelected: textColors.normal,
        textDisabled: rawColors.gray.light,
        border: rawColors.gray.light,
    },
    pill: {
        background: rawColors.white,
        backgroundSelected: rawColors.blue.lightExtreme,
        backgroundDisabled: rawColors.gray.lightExtreme,
        color: textColors.gray.normal,
        colorSelected: textColors.gray.dark,
        colorDisabled: textColors.gray.light,
        border: rawColors.blue.light,
    },
    chip:{
        styles:{
            outlined:{
                backgroundColor: rawColors.white,
                contentColor: textColors.gray.dark,
                borderColor: rawColors.gray.light,
                hoverBackgroundAndBorderColor: rawColors.blue.light,
            },
            outlinedBlue:{
                backgroundColor: rawColors.white,
                contentColor: rawColors.blue.dark,
                borderColor: rawColors.blue.dark,
                hoverBackgroundAndBorderColor: rawColors.blue.light,
            },
            filled:{
                backgroundColor: rawColors.blue.normal,
                contentColor: textColors.white,
                borderColor: rawColors.blue.normal,
                hoverBackgroundAndBorderColor: rawColors.blue.light,
            },
            filledLight:{
                backgroundColor: rawColors.blue.lightExtreme,
                contentColor: rawColors.blue.dark,
                borderColor: rawColors.blue.lightExtreme,
                hoverBackgroundAndBorderColor: rawColors.blue.lightExtreme,
            },
            filledDark:{
                backgroundColor:"#11365b",
                contentColor: textColors.white,
                borderColor: "#11365b",
                hoverBackgroundAndBorderColor: rawColors.blue.light,
            },
            warning:{
                backgroundColor: rawColors.yellow.light,
                contentColor: textColors.gray.dark,
                borderColor: rawColors.yellow.light,
                hoverBackgroundAndBorderColor: rawColors.yellow.light,
            },
            error:{
                backgroundColor: rawColors.red.normal,
                contentColor: textColors.white,
                borderColor: rawColors.red.normal,
                hoverBackgroundAndBorderColor: rawColors.red.normal,
            },
            disabled:{
                backgroundColor: rawColors.gray.lightExtreme,
                contentColor: textColors.gray.light,
                borderColor: rawColors.gray.lightExtreme,
                hoverBackgroundAndBorderColor: rawColors.gray.lightExtreme,
            }
        },
        avatar:{
            styles:{
                filled:{
                    backgroundColor: rawColors.blue.light,
                    contentColor: textColors.white,
                },
                outlined:{
                    backgroundColor: rawColors.white,
                    contentColor: textColors.gray.dark,
                },
                warning:{
                    backgroundColor: rawColors.yellow.normal,
                    contentColor: textColors.gray.dark,
                },
                error:{
                    backgroundColor: rawColors.red.normal,
                    contentColor: textColors.white,
                },
                dimmed:{
                    backgroundColor: rawColors.gray.lightExtreme,
                    contentColor: textColors.gray.dark,
                }
            }
        }
    },
    messageCard: {
        backgroundHover: rawColors.blue.normal,
        success: {
            border: stateColors.success,
        },
        warning: {
            border: stateColors.warning
        },
        error: {
            border: stateColors.error
        },
        info: {
            border: rawColors.blue.light
        }
    },
    org: {
        card: {
            background: {
                root: rawColors.blue.lightExtreme,
                committee: rawColors.white,
                workgroup: rawColors.gray.lightExtreme
            }
        }
    },
    customForm: {
        answer: {
            formFieldHeader: {
                backgroundHover: rawColors.gray.lightExtreme,
                borderHover: rawColors.gray.light
            },
            formFieldCard: {
                cardHeader: {
                    background: rawColors.blue.light,
                    text: textColors.normal,
                },
                body: {
                    background: {
                        default: rawColors.white,
                        attention: rawColors.beige.normal,
                        hover: rawColors.gray.lightExtreme
                    }
                },
                border: rawColors.gray.darkExtreme
            }
        }
    },
    scrollContainer: {
        borderHover: rawColors.blue.lightExtreme
    },
    loadingContainer: {
        background: rawColors.white,
    },
    modal: {
        background: rawColors.white,
    },
    inspectionState: {
        pending: {
            backgroundSelected: rawColors.gray.lightExtreme,
            text: textColors.normal,
            textHover: textColors.normal
        },
        passed: {
            backgroundSelected: rawColors.green.normal,
            text: textColors.white,
            textHover: textColors.white
        },
        failed: {
            backgroundSelected: rawColors.red.normal,
            text: textColors.white,
            textHover: textColors.white

        }
    },
    tooltip: {
        border: rawColors.gray.dark,
        text: textColors.normal
    },
    buttonDiv:{
        defaultHoverBackgroundColor: rawColors.gray.lightExtreme,
    },
    riskCategory: (category: RiskCategory) =>
    {
        if (category === 'Acceptabel risiko')
            return rawColors.green.light;

        else if (category === 'Lille risiko')
            return rawColors.yellow.normal;

        else if (category === 'Moderat risiko')
            return rawColors.yellow.dark;

        else if (category === 'Høj risiko')
            return rawColors.red.normal;

        else
            return rawColors.gray.light;
    },
    background
};
export type ColorSystem = typeof colors;


function getUserRoleColor (roleId: string | null): string
{
    const employerRoles: RoleId[] = [
        'employer', 'employer_rep', 'supervisor',
    ];

    if (employerRoles.find(rid => rid === roleId))
        return colors.avatar.userRole.employer;

    return colors.avatar.userRole.employee;
}